import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SAVE_DRAFT_SUCCESS = 'DRAFT :: SAVE_SUCCESS';

export type TSaveDraftSuccessAction = IReduxAction<typeof SAVE_DRAFT_SUCCESS>;

export const saveDraftSuccess = actionGenerator<typeof SAVE_DRAFT_SUCCESS>(SAVE_DRAFT_SUCCESS);
